._9q9w3a0 {
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  display: flex;
  flex-direction: column;
  gap: 48px;
  color: var(--_1qu8za24);
}
._9q9w3a1 {
  display: flex;
  gap: 12px;
  align-self: end;
}
._9q9w3a2 {
  margin: 0 auto;
}